<style scoped lang="less" src="./../assets/Header.less"></style>
<template>
  <div>
    <div class="header-wap">
      <div class="back-box" v-if="showBack" @click="back()" :data-track="backTrack">
        <img src="./../assets/images/home/back-icon.png" class="back"/>
      </div>
      <div v-if="showHome" class="home-box" @click="goHome()" :data-track="homeTrack ? homeTrack : 'djk_kj_lessons_kjhomepage'">
        <img src="./../assets/images/icon/home@2x.png" class="home"/>
      </div>
      <div :class="[showBack ? 'tit' : 'tit tit-w1']" :style="showHome?'width:52%':''">{{title}}</div>
      <div class="user-box" v-if="showUser" @click="goMy()" data-track="djk-kj-home_personalcenter">
        <img src="./../assets/images/home/user-icon.png" class="user"/>
      </div>
      <div class="broker-box" v-else-if="isFenXiao" @click="goBroker()">
        <img src="./../assets/images/home/fenxiao@3x.png" class="broker"/>
        <p class="explain" v-if="showPrice">分享赚￥{{course.distributionPrice}}</p>
        <!--<span>￥{{course.distributionPrice}}</span>-->
      </div>
      <div class="submit-box" v-if="showSubmitBtn" @click="bindSubmit">
        <div class="submit-btn">提交</div>
      </div>
      <div class="fenxiao-mask" v-if="isFenXiao && shareMask && showMask" @click="hideMask">
        <img :src="shareMask" class="fenxiao-image">
        <p>长按保存图片并将图片发送给好友</p>
      </div>
      <div class="share-box" v-if="showShare" @click="bindShare">
        <img src="./../assets/images/scholarships/share-icon.png" class="share"/>
      </div>
    </div>
    <AdTip/>
  </div>
</template>
<script>
  import AdTip from '@/components/AdTip';
  import { mapGetters } from 'vuex';
  import auth from '@/lib/auth';
  import Cookies from 'js-cookie';
  import { browser } from '@/lib/ua';
  import { MessageBox } from 'mint-ui';

  export default {
    name: 'Header',
    components: { AdTip },
    props: {
      title: {
        type: String
      },
      backTrack: {
        type: String
      },
      homeTrack: {
        type: String
      },
      showHomeBtn: {
        type: Boolean
      },
      showUserBtn: {
        default: null
      },
      showBrokerBtn: {
        type: Boolean,
        default: false
      },
      showSubmitBtn: {
        type: Boolean,
        default: false
      },
      page: {
        type: String
      },
      backUrl: String,
      showBack: {
        type: Boolean,
        default: true
      },
      showShare: {
        type: Boolean,
        default: false
      },
      shareTrack: {
        type: String
      }
    },
    data() {
      return {
        uid: null,
        canScroll: false,
        shareMask: null,
        showMask: false,
        showPrice: true,
        currentTrack: {},
        track: [{
          // 订阅父课程详情
          type: 15,
          dsp: 'djk-dy-lessons_Share_dsp',
          click: 'djk-dy-lessons_Share_click',
          source: 'djk-dy-lessons_UserSource'
        },
          // 精品课父课程详情
        {
          type: 17,
          dsp: 'djk-jp-lessons_Share_dsp',
          click: 'djk-jp-lessons_Share_click',
          source: 'djk-jp-lessons_UserSource'
        },
          // 组合课课程详情（新）
        {
          type: 6,
          dsp: 'djk-kj-combined-new_Share_dsp',
          click: 'djk-kj-combined-new_Share_click',
          source: 'djk-kj-combined-new_UserSource'
        },
        {
          type: 7,
          dsp: 'djk-kj-combined-new_Share_dsp',
          click: 'djk-kj-combined-new_Share_click',
          source: 'djk-kj-combined-new_Share_click'
        },
        {
          type: 8,
          dsp: 'djk-kj-combined-new_Share_dsp',
          click: 'djk-kj-combined-new_Share_click',
          source: 'djk-kj-combined-new_Share_click'
        },
          // 开讲课程详情（新）
        {
          type: 0,
          dsp: 'djk-kj-lessons-new_Share_dsp',
          click: 'djk-kj-lessons-new_Share_click',
          source: 'djk-kj-lessons-new_UserSource'
        },
          // 系列课课程详情（新）
        {
          type: 1,
          dsp: 'djk-kj-serieslesson-new_Share_dsp',
          click: 'djk-kj-serieslesson-new_Share_click',
          source: 'djk-kj-serieslesson-new_UserSource'
        },
          // 视频专辑详情
        {
          type: 10,
          dsp: 'djk-sp-lessons_Share_dsp',
          click: 'djk-sp-lessons_Share_click',
          source: 'djk-sp-lessons_UserSource'
        },
          // 视频独立课详情
        {
          type: 9,
          dsp: 'djk-sp-medias_Share_dsp',
          click: 'djk-sp-medias_Share_click',
          source: 'djk-sp-medias_UserSource'
        },
          // 专辑微课详情页
        {
          type: 4,
          dsp: 'djk-wk-lessons_Share_dsp',
          click: 'djk-wk-lessons_Share_click',
          source: 'djk-wk-lessons_UserSource'
        },
          // 微课详情页——独立课程
        {
          type: 3,
          dsp: 'djk-wk-medias_Share_dsp',
          click: 'djk-wk-medias_Share_click',
          source: 'djk-wk-medias_UserSource'
        }
        ]
      };
    },
    computed: {
      ...mapGetters({
        courseInfo: 'courseInfo',
        newCourseInfo: 'newCourseInfo',
        userInfo: 'userInfo'
      }),
      getLiveId() {
        return this.$route.params.liveId ? parseInt(this.$route.params.liveId.toString().substring(String(this.$route.params.liveId).indexOf('-') + 1), 10) : 0;
      },
      course() {
        if (this.newCourseInfo && this.newCourseInfo.id === this.getLiveId) {
          return this.newCourseInfo;
        }
        return this.courseInfo;
      },
      isFenXiao() {
        if (this.$route.query.hideHeaderRight) {
          return false;
        }
        return this.showBrokerBtn
          && (this.course && this.course.distribution === 1);
      },
      showUser() {
        if (this.$route.query.hideHeaderRight) {
          return false;
        }
        if (typeof this.showUserBtn === 'boolean') {
          return this.showUserBtn;
        } else if (!this.showUserBtn) {
          return !this.isFenXiao;
        }
        return Boolean(this.showUserBtn);
      },
      showHome() {
        if (this.$route.query.hideHeaderHome) {
          return false;
        }
        return this.showHomeBtn;
      },
      nowTrack() {
        let obj;
        if (this.course.type >= 0) {
          this.track.map((item) => {
            if (this.course.type === item.type) {
              obj = item;
            }
            return null;
          });
        }
        return obj;
      }
    },
    created() {
      this.uid = this.$route.query.uid;
      window.addEventListener('scroll', () => {
        this.showPrice = false;
      });
      this.controlPrice();
      setTimeout(() => {
        if (this.nowTrack) {
          console.log(this.nowTrack);
          window.Tracking.initTrackUrl(2, this.nowTrack.dsp, `lessons_id=${this.course.id}`);
          if (browser.qq) {
            window.Tracking.initTrackUrl(2, this.nowTrack.source, 'SharingChannel=0');
          }
          if (browser.wx) {
            window.Tracking.initTrackUrl(2, this.nowTrack.source, 'SharingChannel=1');
          }
        }
      }, 1000);
    },
    methods: {
      back() {
        if (this.page === 'xwdetail' || this.page === 'xwsub') {
          this.$emit('headerPauseAudio');
        }
        this.$emit('backTrackFunc'); // 旧使用方法
        this.$emit('trackFunc', 'back');
        if (this.backUrl) {
          location.href = this.backUrl;
        } else {
          const isApp = Cookies.get('MT_USER_INFO') ? Boolean(Cookies.get('MT_USER_INFO')) : false;
          if (isApp) {
            if (window.MT) {
              window.MT.tryBackToNativePage();
            } else {
              MessageBox({
                message: '网页未加载完毕，是否刷新重试',
                showCancelButton: true,
                confirmButtonText: '刷新',
                cancelButtonText: '取消'
              }).then((action) => {
                if (action === 'confirm') {
                  location.reload();
                }
              });
            }
          } else {
            this.$router.go(-1);
          }
        }
      },
      goMy() {
        if (this.page === 'xwdetail' || this.page === 'xwsub') {
          this.$emit('headerPauseAudio');
        }

        this.$router.push({ name: 'UserLive' });
      },
      goHome() {
        if (this.page === 'xwdetail' || this.page === 'xwsub') {
          this.$emit('headerPauseAudio');
        }
        if (this.$route.name === 'MediaCourseNew') {
          this.$router.push({ name: 'detail', params: { id: this.$route.params.activityId } });
          return;
        }

        this.$router.push({ name: 'home' });
      },
      // 提交事件
      bindSubmit() {
        this.$emit('bindSubmit');
      },
      // 获得分销
      goBroker() {
        if (!auth.check('user')) {
          auth.login('user', this.$route.query.code);
          return;
        }
        // 未绑定手机号去绑定手机号
        if (this.userInfo && Number(this.userInfo.isHaveMobile) === 0) {
          this.$router.push({ name: 'UserBinding' });
          return;
        }
        if (!this.shareMask) {
          window.Tracking.initTrackUrl(2, this.nowTrack.click, `lessons_id=${this.course.id}`);
          this.$store.dispatch('getShareImage', {
            id: this.course.id,
            pid: this.course.serialCourse ? this.course.serialCourse.id : null
          }).then((shareData) => {
            this.shareMask = shareData.shareUrl;
            this.showMask = true;
          });
        } else {
          this.showMask = true;
        }
      },
      hideMask(e) {
        if (e.target.className !== 'fenxiao-image') {
          this.showMask = false;
        }
      },
      controlPrice() {
        document.onclick = (e) => {
          if (e.target.className !== 'explain') {
            this.showPrice = false;
          }
        };
      },
      bindShare() {
        this.$emit('bindShare', 'header'); // 2表示 顶部分享按钮
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Header.vue?0742dd68